import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 5,
};

export const profStandardsListTableControllerSlice = createSlice({
    name: 'profStandardsListTableControllerSlice',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
    },
});

export const {changeCurrentPage} = profStandardsListTableControllerSlice.actions;

export default profStandardsListTableControllerSlice.reducer;
